const responses = [
    {id: 2, title: 'Purchase Response'},
    {id: 3, title: 'Update Response'}
]

export default responses